import {
    FETCH_EMAILRULES_BEGIN,
  FETCH_EMAILRULES_SUCCESS,
    FETCH_EMAILRULES_FAILURE,
    FETCH_EMAILRULESATTACHEMENT_BEGIN,
    FETCH_EMAILRULESATTACHEMENT_SUCCESS,
    FETCH_EMAILRULESATTACHEMENT_FAILURE
  } from '../constants/emailRules';

const initialState={
    emailRules: [],
    AttachmentSecurity:[],
    isLoading:false,
    error:""
}


export const getemailRuleReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_EMAILRULES_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_EMAILRULES_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            emailRules:null
        };
    case FETCH_EMAILRULES_SUCCESS:
        return {
            ...initialState,
            emailRules:payload.emailRules,
            isLoading:true,
         };
     case FETCH_EMAILRULESATTACHEMENT_BEGIN: {
         return {
             ...state,
             isLoading: true,
             error: null,
         };
     }
     case FETCH_EMAILRULESATTACHEMENT_FAILURE:
         return {
             ...initialState,
             isLoading: false,
             AttachmentSecurity: null
         };
     case FETCH_EMAILRULESATTACHEMENT_SUCCESS:
         return {
             ...initialState,
             AttachmentSecurity: payload.AttachmentSecurity,
             isLoading: true,
         };

    default:
        return state;
 }
}
